import React from 'react';
import { PropsFromRedux } from '.';
import ModalWrapper from '../common/ModalWrapper';
import RatingForm from '../RatingForm';

interface Props extends PropsFromRedux {}

const RateModal: React.FC<Props> = ({ hideModal, modal }) => (
  <ModalWrapper hideModal={hideModal}>
    <RatingForm waybill={modal.ownProps?.waybill} />
  </ModalWrapper>
);

export default RateModal;
